/**
 * Computes the scale factor needed to make a rotated image
 * fully cover its original (non-rotated) bounding box,
 * eliminating empty corners.
 */
export const getRotationCoverScale = (
  rotationDeg: number,
  aspectRatio: number,
): number => {
  // Deviation from the nearest 90° multiple
  const remainder = ((rotationDeg % 90) + 90) % 90;
  const deviationDeg = Math.min(remainder, 90 - remainder);

  if (deviationDeg < 0.01) {
    return 1;
  }

  const theta = deviationDeg * (Math.PI / 180);
  const cos = Math.cos(theta);
  const sin = Math.sin(theta);

  // At 90°/270° the effective aspect ratio is inverted
  const nearest90 = Math.round(rotationDeg / 90) * 90;
  const nearestMod = ((nearest90 % 360) + 360) % 360;
  const effectiveAspect =
    nearestMod === 90 || nearestMod === 270 ? 1 / aspectRatio : aspectRatio;

  const scaleW = cos + sin / effectiveAspect;
  const scaleH = effectiveAspect * sin + cos;

  return Math.max(scaleW, scaleH);
};
